<template>
    <div class="call-task-manage">
        <el-divider content-position="left">外部资源外呼任务管理</el-divider>
        <div class="cal-tas-search-con">
            <div>
                <!-- <select-input :options="first_cate_options" value="source" label="label" placeholder="请选择分类"
                    controller="\App\Controller\Qyh\CallTaskController" method="list" :host="hyperfHost"
                    @createSearch="createSearch" /> -->
            </div>
            <div style="margin-left: auto; display: flex; justify-content:space-evenly;gap: 0.2rem;">
                <el-button type="primary" size="mini" @click="$router.push('ct_cate_manage')">分类管理</el-button>
                <!-- <el-button type="primary" size="mini" @click="openDistributeDialog">分配资源</el-button> -->
                <!-- <import class="cal-tas-im-cla" data="\App\Http\Controllers\Admin\CommonController::handleCallTask">
                    <template v-slot:name>
                        导 入
                    </template>
</import> -->
                <!-- <import @imported="imported" :extraData="cateData"
                    data="\App\Http\Controllers\Admin\CommonController::handleCallTask">
                    <template v-slot:name>
                        <span>导 入</span>
                        <el-tooltip effect="dark" content="点击查看导入模版示例" placement="top">
                            <i @click.stop="showExampleDialog" style="cursor: pointer;color: " class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                </import> -->
                <!-- <el-button type="primary" size="mini" @click="dialog_import = true">
                    <span>开始导入</span>
                    <el-tooltip effect="dark" content="点击查看导入模版示例" placement="top">
                        <i @click.stop="showExampleDialog" style="cursor: pointer;color: " class="el-icon-info"></i>
                    </el-tooltip>
                </el-button> -->
                <el-button type="primary" size="mini" @click="refreshPhoneInfoAll" disabled>
                    <span>
                        剩余未刷新数量
                    </span>
                    <!-- <el-tooltip effect="dark" content="剩余未刷新数量" placement="top" v-if="computedData['not_refresh']">
                        <span>
                            ({{ computedData['not_refresh'] }})
                        </span>
                    </el-tooltip> -->
                    <el-tooltip effect="dark" content="剩余未刷新数量" placement="top" v-if="notRefreshed">
                        <span>
                            ({{ notRefreshed }})
                        </span>
                    </el-tooltip>
                </el-button>

                <!-- <el-button type="primary" size="mini" @click="refreshIsMemberAndIsOrder">
                    <span>
                        更新是否会员、订单
                    </span>
                    <!== <el-tooltip effect="dark" content="剩余未刷新数量" placement="top" v-if="computedData['not_refresh']">
                        <span>
                            ({{ computedData['not_refresh'] }})
                        </span>
                    </el-tooltip> ==>
                    <el-tooltip effect="dark" content="剩余未刷新数量" placement="top" v-if="notRefreshedIsMemberAndIsOrder">
                        <span>
                            ({{ notRefreshedIsMemberAndIsOrder }})
                        </span>
                    </el-tooltip>
                </el-button> -->
            </div>
        </div>

        <!-- <div class="call-task"> -->
        <!-- <div class="call-task-col"> -->
        <!-- <count-cate class="count-con" v-for="(item, index) in tableData" :key="index">
                <template v-slot:body>
                    <span class="c-title">{{ item.call_cate.first_level }}</span>
                    <span>
                        <span>
                            总数
                        </span>
                        <span>
                            {{ item.not_assign + item.assigned }}
                        </span>
                    </span>
                    <span class="c-c-assigned">
                        <span>
                            已分配
                        </span>
                        <span>
                            {{ item.assigned }}
                        </span>
                    </span>
                    <span class="c-c-not-assign">
                        <span>
                            未分配
                        </span>
                        <span>
                            {{ item.not_assign }}
                        </span>
                    </span>
                </template>
            </count-cate> -->
        <!-- <div style="display: flex;gap: 0.2rem;flex-wrap: wrap;"> -->
        <!-- <div style="column-count: 3;column-gap: 8px;">
                <el-tooltip effect="dark" content="点击查看子分类" placement="top" v-for="(item, index) in tableData" :key="index">
                    <el-card @click.native="$router.push({name:'CallTaskManageSecond',params: {id: item.call_cate.pid}})" shadow="always" class="box-card-my">
                        <div slot="header" class="clearfix">
                            <span class="box-card-title">{{ item.call_cate.first_level }}</span>
                            <!== <el-button style="float: right; padding: 3px 0" type="text" @click="openDistributeDialog">分配资源</el-button> ==>
                        </div>
                        <table class="field-table" border>
                            <tr>
                                <td>
                                    <span class="first-td">分配情况:</span>
                                </td>
                                <td>
                                    <el-tag class="table-dis" size="mini" type="primary" effect="dark">
                                        <span>
                                            总数
                                        </span>
                                        <span>
                                            {{ item.not_assign + item.assigned }}
                                        </span>
                                    </el-tag>
                                </td>
                                <td>
                                    <el-tag class="table-dis" size="mini" type="success" effect="dark">
                                        <span>
                                            已分配
                                        </span>
                                        <span>
                                            {{ item.assigned }}
                                        </span>
                                    </el-tag>
                                </td>
                                <td>
                                    <el-tag class="table-dis" size="mini" type="danger" effect="dark">
                                        <span>
                                            未分配
                                        </span>
                                        <span>
                                            {{ item.not_assign }}
                                        </span>
                                    </el-tag>
                                </td>
                            </tr>
                        </table>
                    </el-card>
                </el-tooltip>
            </div> -->
        <el-collapse v-model="activeNames" @change="handleChange_col"
            style="box-shadow: 0 15px 30px rgba(0, 0, 0, .3);border-radius: 10%;margin-top: 0.2rem;">
            <el-collapse-item title="一致性 Consistency" :name="v" v-for="(itemAll, v, index) in tableData" :key="index">
                <template slot="title">
                    <span class="col-title">{{ v }}</span>
                </template>
                <hr>
                <div class="el-card-con">
                    <el-card shadow="always" class="box-card-my" v-for="(item, ind) in itemAll" :key="ind">
                        <div slot="header" class="clearfix">
                            <span class="box-card-title">
                                {{ item.call_cate.name }}
                                <el-tooltip effect="dark" :content="item.call_cate.desc" placement="top"
                                    v-if="item.call_cate.desc">
                                    <i style="font-size: small;" class="el-icon-info"></i>
                                </el-tooltip>
                            </span>
                            <!-- <el-button style="float: right; padding: 3px 0" type="text"
                                @click="openDistributeDialog(item.call_cate.id)">分配资源</el-button> -->
                        </div>
                        <table class="field-table" border>
                            <tr>
                                <td>
                                    <span class="first-td">分配情况:</span>
                                </td>
                                <td>
                                    <el-tag class="table-dis" size="mini" type="primary" effect="dark">
                                        <span>
                                            总数
                                        </span>
                                        <span>
                                            {{ item.not_assign + item.assigned }}
                                        </span>
                                    </el-tag>
                                </td>
                                <td>
                                    <el-tag class="table-dis" size="mini" type="success" effect="dark">
                                        <span>
                                            已分配
                                        </span>
                                        <span>
                                            {{ item.assigned }}
                                        </span>
                                    </el-tag>
                                </td>
                                <td>
                                    <el-tag class="table-dis" size="mini" type="danger" effect="dark">
                                        <span>
                                            未分配
                                        </span>
                                        <span>
                                            {{ item.not_assign }}
                                        </span>
                                    </el-tag>
                                </td>
                            </tr>
                            <tr v-if="item.assigned">
                                <td>
                                    <span class="first-td">
                                        已分配完成情况:
                                        <i style="color: #67C23A">( {{ (((item.effect + item.not_effect) /
                    item.assigned) *
                    100).toFixed(2) }}% )</i><i
                                            v-if="(((item.effect + item.not_effect) / item.assigned) * 100).toFixed(2) == 100.00"
                                            class="el-icon-circle-check"
                                            style="color: #67C23A;margin-left: 0.1rem"></i></span>
                                </td>
                                <td>
                                    <el-tag class="table-dis" size="mini" type="success" effect="dark">
                                        <span>
                                            有效沟通
                                        </span>
                                        <span>
                                            {{ item.effect }}
                                        </span>
                                    </el-tag>
                                </td>
                                <td>
                                    <el-tag class="table-dis" size="mini" type="warning" effect="dark">
                                        <span>
                                            无效沟通
                                        </span>
                                        <span>
                                            {{ item.not_effect }}
                                        </span>
                                    </el-tag>
                                </td>
                                <td>
                                    <el-tag class="table-dis" size="mini" type="danger" effect="dark">
                                        <span>
                                            未联系
                                        </span>
                                        <span>
                                            {{ item.assigned - (item.effect + item.not_effect) }}
                                        </span>
                                    </el-tag>
                                </td>
                            </tr>
                        </table>
                        <div class="btn-con">
                            <el-button type="warning" size="mini" round
                                @click="openDisLogDrawer(item.call_cate.id, v, item.call_cate.name)">分配记录</el-button>
                            <el-button type="success" size="mini" round
                                @click="openDistributeDialog(item.call_cate.id)">分配资源</el-button>
                            <el-button type="primary" size="mini" round
                                @click="$router.push({ name: 'CallTask', params: { cate: item.cate_id, keyword: 'resource', tword: '总数', other: JSON.stringify({ first_level: v, second_level: item.call_cate.name }) } })">查看全部</el-button>
                        </div>
                    </el-card>
                </div>
            </el-collapse-item>
        </el-collapse>
        <!-- </div> -->

        <el-dialog :visible.sync="dialog" @closeDialog="closeDialog" @beforeCloseDialog="beforeCloseDialog" width="50%"
            center>
            <template v-slot:title>
                <span class="cal-tas-m-dia-title">
                    分配资源
                </span>
            </template>
            <div class="cal-tas-m-bg-con">
                <button-group :buttonGroup="1" :options="buttonGroupOptions" @buttonGroupChange="buttonGroupChange" />
                <div style="margin-top:0.2rem;text-align: center">
                    <span>分配条件(不选默认全部分配)</span>
                    <el-checkbox-group v-model="distribute.phone_cate" style="margin-top: 0.2rem">
                        <el-checkbox label="1">有手机号</el-checkbox>
                        <el-checkbox label="2">有渠道拉取</el-checkbox>
                        <el-checkbox label="3">有清洗号码</el-checkbox>
                    </el-checkbox-group>
                </div>
                <div v-if="distribute.dis_type === 1">
                    <el-card shadow="hover" class="box-card">
                        <div slot="header" class="clearfix">
                            <span>选择人员</span>
                        </div>
                        <div class="text item">
                            <checkbox-com ref="checkboxCom" :options="callerOptions" label="username"></checkbox-com>
                            <!-- <role-member/> -->
                        </div>
                    </el-card>
                    <el-card shadow="hover" class="box-card">
                        <div slot="header" class="clearfix">
                            <span>每人分配条数</span>
                        </div>
                        <div class="text item">
                            <el-form :model="distribute" ref="distribute" label-width="0px" class="demo-dynamic">
                                <el-form-item prop="avgNum" label="" :rules="[
                    { required: true, message: '请输入每人分配条数', trigger: 'blur' },
                    { min: 1, message: '请输入正确的每人分配条数', trigger: 'blur' },
                ]">
                                    <el-input type="number" clearable v-model="distribute.avgNum"
                                        size="mini"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-card>
                </div>
                <div v-else-if="distribute.dis_type === 2" style="margin-top: 0.2rem;">
                    <checkbox-input ref="checkboxInput" :options="callerOptions" label="username" />
                </div>
                <div style="display: flex;margin-top: 0.2rem">
                    <div style="margin-left: auto;">
                        <el-button type="primary" @click.native="submitForm('distribute')" size="mini">提交</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialog_import" @closeDialog="closeDialog_import"
            @beforeCloseDialog="beforeCloseDialog_import" width="50%" center>
            <template v-slot:title>
                <span class="cal-tas-m-dia-title">
                    导入数据
                </span>
            </template>
            <div class="cal-tas-m-bg-con-s">
                <call-task-cate @handleChange="handleChange" />
                <div style="text-align:right">
                    <import v-if="cateData" @imported="imported" :extraData="cateData"
                        data="\App\Http\Controllers\Admin\CommonController::handleCallTask">
                        <template v-slot:name>
                            导 入
                        </template>
                    </import>
                </div>
            </div>
        </el-dialog>

        <el-drawer :visible.sync="disLogDrawer" direction="rtl" :before-close="handleDisLogClose" size="50%">
            <template slot="title">
                <span style="color:#409eff;font-size:medium">分配记录</span>
            </template>
            <dis-log :id="disLogId" style="padding: 0 0.2rem 0.6rem 0.2rem;height: 100vh;overflow: scroll;" />
        </el-drawer>

        <el-dialog :visible.sync="dialog_example" @closeDialog="closeDialog_example"
            @beforeCloseDialog="beforeCloseDialog_example" width="50%" center>
            <template v-slot:title>
                <span class="cal-tas-m-dia-title">
                    导入模版说明
                </span>
            </template>
            <div v-if="!imgExampleUrl" style="text-align: center">图片加载中...</div>
            <el-image v-else :src="imgExampleUrl" :preview-src-list="[imgExampleUrl]">
            </el-image>
        </el-dialog>
    </div>
</template>

<script>
import blade from '../../blade/Blade';
import CountCate from '../../commonReform/CountCate';
import Import from '../../commonReform/Import';
import SelectInput from '../../commonReform/SelectInput';
import DialogCom from '../../commonReform/DialogCom';
import ButtonGroup from '../../commonReform/ButtonGroup';
import CheckboxCom from '../../commonReform/CheckboxCom';
import CheckboxInput from '../../commonReform/CheckboxInput';
import CallTaskCate from './Components/CallTaskCate';
import DisLog from './Components/DisLog';
import RoleMember from '../../commonReform/RoleMember.vue';
export default {
    name: 'CallTaskManage',
    components: { blade, CountCate, Import, SelectInput, DialogCom, ButtonGroup, CheckboxCom, CheckboxInput, CallTaskCate, DisLog, RoleMember },
    data() {
        return {
            searchArr: ['', '天眼查', '企查查', '丰拓云'],
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            first_cate_options: [
                {
                    source: 1,
                    label: '天眼查'
                },
                {
                    source: 2,
                    label: '企查查'
                },
                {
                    source: 3,
                    label: '丰拓云'
                },
            ],
            search: null,
            tableData: [],
            dialog: false,
            buttonGroupOptions: [
                {
                    label: '平均分配',
                    value: 1
                },
                {
                    label: '自定义分配',
                    value: 2
                },
            ],
            distribute: {
                dis_type: 1,
                avgNum: null,
                phone_cate: ['1', '2', '3']
            },
            callerOptions: [],
            dialog_import: false,
            cateData: '',
            activeNames: [],
            cateId: '',
            disLogId: '',
            disLogDrawer: false,
            imgExampleUrl: '',
            dialog_example: false,
            notRefreshed: null,
            notRefreshedIsMemberAndIsOrder: null
        };
    },
    methods: {
        loadTable1() {
            this.$axios.get(`${this.hyperfHost}api/call_task/list`, {
                loadingClose: true,
                params: {
                    search: this.search,
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.tableData = data.data
                    this.activeNames = data.col_name
                }
            }).catch()
        },
        loadTable() {
            this.$axios.get(`${this.hyperfHost}api/call_task/list_new`, {
                loadingClose: true,
                params: {
                    search: this.search,
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.tableData = data.data
                    this.activeNames = data.col_name
                }
            }).catch()
        },
        createSearch(search) {
            this.search = search
            this.loadTable()
        },
        closeDialog() {
            this.cateId = ''
        },
        beforeCloseDialog() {

        },
        closeDialog_example() {

        },
        beforeCloseDialog_example() {

        },
        closeDialog_import() {
            this.cateData = ''
            this.dialog_import = false
        },
        beforeCloseDialog_import() {

        },
        openDistributeDialog(id) {
            this.cateId = id
            this.loadCaller()
            this.dialog = true
        },
        loadCaller() {
            this.$axios.get('api/api3_call_task/get_caller', {
                loadingClose: true
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.callerOptions = data.data
                }
            }).catch()
        },
        buttonGroupChange(val) {
            this.distribute.dis_type = val
        },
        submitForm(formName) {
            this.distribute.cateId = this.cateId
            if (this.distribute.dis_type === 1) {
                this.distribute.checkBoxCom = this.$refs.checkboxCom.checkList
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$axios
                            .post('/api/api3_call_task/distribute', this.distribute)
                            .then(res => {
                                const { data } = res
                                if (data.code === 0) {
                                    this.$message.success(data.msg)
                                    this.loadTable()
                                    this.dialog = false
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                    } else {
                        return false
                    }
                })
            } else if (this.distribute.dis_type === 2) {
                this.distribute.checkboxInput = this.$refs.checkboxInput.avgNum
                this.$axios
                    .post('/api/api3_call_task/distribute', this.distribute)
                    .then(res => {
                        const { data } = res
                        if (data.code === 0) {
                            this.$message.success(data.msg)
                            this.loadTable()
                            this.dialog = false
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
            } else {
                return false
            }
        },
        handleChange(val) {
            this.cateData = val
        },
        imported() {
            this.dialog_import = false
        },
        refreshPhoneInfoAll() {
            this.$message.success('已在后台开始更新,可能比较耗时!')
            setTimeout(() => {
                this.$axios.get('/api/api3_call_task/refresh_phone_info_all').then(({ data }) => {
                    if (data.code === 0) {
                        this.$message.success(data.msg)
                    } else {
                        this.$message.success(data.message)
                    }
                }).catch()
            }, 500)
        },
        handleChange_col(val) {

        },
        openDisLogDrawer(id, f, s) {
            this.disLogId = id
            sessionStorage.setItem('ysyCallTaskLevelF', f)
            sessionStorage.setItem('ysyCallTaskLevelS', s)
            this.disLogDrawer = true
        },
        handleDisLogClose(done) {
            this.disLogId = ''
            done();
        },
        loadImgExample() {
            this.$axios.get('api/api3_call_task/get_example_img').then(({ data }) => {
                if (data.code === 0) {
                    this.imgExampleUrl = data.url
                }
            }).catch()
        },
        showExampleDialog() {
            this.loadImgExample()
            this.dialog_example = true
        },
        loadNotRefreshed() {
            this.$axios.get('/api/api3_call_task/get_not_refreshed',{
                loadingClose: true,
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.notRefreshed = data.data
                }
            }).catch()
        },
        refreshIsMemberAndIsOrder() {
            this.$message.success('已在后台开始更新,可能比较耗时!')
            setTimeout(() => {
                this.$axios.get('/api/api3_call_task/refresh_is_member_and_is_order').then(({ data }) => {
                    if (data.code === 0) this.$message.success(data.message)
                }).catch()
            }, 200)
        },
        loadNotRefreshedIsMemberAndIsOrder() {
            this.$axios.get('/api/api3_call_task/is_member_and_is_order_all_updated').then(({ data }) => {
                if (data.code === 0) {
                    this.notRefreshedIsMemberAndIsOrder = data.data
                }
            }).catch()
        },
        // this.$refs[formName].validate(valid => {
        //     if (valid) {
        //         this.$axios
        //             .post('api/api3_call_task/distribute', this.distribute)
        //             .then(res => {
        //                 const { data } = res
        //                 if (data.code === 0) {
        //                     this.loadTable()
        //                 } else {
        //                     this.$message.error(data.msg)
        //                 }
        //             })
        //     } else {
        //         return false
        //     }
        // })
        // }
    },
    mounted() {
        // this.$bus.$on('ysyCallTaskNeedCate',() => {
        //     console.log('emit')
        //     this.$bus.$emit('ysyCallTaskLevel',JSON.stringify({first_level:this.f,second_level: this.s}))
        // })
        // this.loadNotRefreshedIsMemberAndIsOrder()
        this.loadTable()
        this.loadNotRefreshed()
        // this.loadTable1()
        // this.loadImgExample()
        // const ws = new WebSocket("ws://localhost:9502");
        // console.log(ws)
    },
    beforeDestroy() {
        // this.$bus.$off('ysyCallTaskNeedCate')
    },
    computed: {
        computedData() {
            const arr = []
            let num = 0;
            for (let item in this.tableData) {
                this.tableData[item].map(i => {
                    num += i.not_refresh
                })
            }
            arr['not_refresh'] = num
            return arr;
        }
    }
}
</script>

<style scoped>
.cal-tas-search-con {
    display: flex;
    align-items: center;
}

.cal-tas-im-cla {
    margin-left: auto;
}

.call-task {
    display: flex;
    background-color: #F2F6FC;
    padding: 0.3rem;
    min-height: calc(100vh - 5.2rem);
    margin-top: 0.2rem;
    justify-content: space-evenly;
}

.call-task-col {
    background-color: #F2F6FC;
    padding: 0.3rem;
    min-height: calc(100vh - 5.2rem);
    margin-top: 0.2rem;
}

.count-con {
    background-color: white;
    border-radius: 10px;
    cursor: pointer;
}

.c-title {
    font-weight: bold;
    font-size: medium;
    color: #409EFF;
}

.c-c-assigned {
    color: #67C23A;
}

.c-c-not-assign {
    color: #F56C6C;
}

.dialog_title {
    font-weight: bold;
    font-size: large;
    color: #409EFF;
}

.cal-tas-m-dia-title {
    font-size: large;
    font-weight: bold;
    color: #409EFF;
}

.cal-tas-m-bg-con {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}

.cal-tas-m-bg-con-s {
    display: flex;
    flex-direction: column;
    justify-content: end;
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}

.box-card {
    margin-top: 0.2rem;
    width: 480px;
}

.call-task-manage>>>.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 200px);
    max-width: calc(100% - 30px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, .3);
}

.call-task-manage>>>.el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
}

.call-task-manage {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.call-task-manage .clearfix:after {
    clear: both
}

.call-task-manage .box-card-my {
    /* width: 9rem; */
    /* height: fit-content; */
    flex: 1;
    flex-basis: 49%;
    box-sizing: border-box;
}

.call-task-manage .box-card-title {
    font-size: large;
    font-weight: bold;
}

/* 表格 */
.call-task-manage .field-table {
    border-color: #eeeaea;
}

.call-task-manage .centered {
    /* 水平居中 */
    text-align: center;
    /* 垂直居中 */
    vertical-align: middle;
}

.call-task-manage .field-table td {
    padding: 0.1rem 0.15rem;
    box-sizing: border-box;
}

.call-task-manage .centered-count {
    text-align: right;
}

/* 表格end */
.call-task-manage .table-dis {
    /* cursor: pointer; */
    font-size: small;
}

.call-task-manage .first-td {
    white-space: nowrap;
}

.call-task-manage .col-title {
    font-size: large;
    font-weight: bold;
    margin-left: 0.2rem;
    color: #409EFF;
}

.call-task-manage .el-card-con {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 0.2rem;
    box-sizing: border-box;
    gap: 0.2rem;
    align-items: stretch;
}

.call-task-manage .btn-con {
    display: flex;
    /* justify-content: space-between; */
    gap: 0.2rem;
    padding-top: 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/CallTaskManage.vue